import { FC, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from "@mui/material";

type Props = {
  open: boolean;
  entityName?: string | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
};

// A signatory VP rejecting a sign off must give a cause so Market Access understands why.
// The confirm button stays disabled until a non-empty reason is entered.
export const RejectSignOffDialog: FC<Props> = ({
  open,
  entityName,
  saving,
  onClose,
  onConfirm
}) => {
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const handleConfirm = () => {
    const trimmed = reason.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
    setReason("");
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Reject sign off</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: 2 }}>
          Rejecting halts the sign off for {entityName || "this entity"}. Market
          Access will be notified and can send it again once the cause has been
          addressed. A cause is required.
        </DialogContentText>
        <TextField
          label="Cause for rejection"
          multiline
          rows={4}
          fullWidth
          required
          autoFocus
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={!reason.trim() || saving}
          loading={saving}
          onClick={handleConfirm}
        >
          Reject sign off
        </Button>
      </DialogActions>
    </Dialog>
  );
};
